import "./CustomTimeline.css";
import React from "react";
import { Box, Typography, Divider } from "@mui/material";
import { DARCKCOLOR } from "../../helpers/Config";
import ReactQuill from "react-quill";
import { sxRowStart, sxText1450020 } from "../../theme/sxStyle";

const CustomTimeline = ({ deteails = [] }) => {
  return (
    <Box display="flex" flexDirection="column" position="relative" mt={3}>
      {!!deteails?.length &&
        deteails.map((item, index) => (
          <Box
            key={index}
            position="relative"
            gap={"8px"}
            mb={2}
            sx={sxRowStart}
          >
            {/*left dot */}
            <Box position="relative" mr={2}>
              <Box
                sx={{
                  width: 17,
                  height: 17,
                  backgroundColor: "green",
                  borderRadius: "50%",
                  border: "3px solid #d4d7da",
                  position: "absolute",
                  top: 0,
                  left: 0,
                  zIndex: 1,
                }}
              />
            </Box>

            {/* right */}
            <Box>
              <Typography
                variant="h6"
                mb={"4px"}
                color={DARCKCOLOR}
                sx={sxText1450020}
              >
                {item.title}
              </Typography>
              {!!item?.description?.length &&
                !!JSON.parse(item?.description)?.ops?.length && (
                  <ReactQuill
                    value={JSON.parse(item.description)}
                    readOnly={true}
                    theme="bubble"
                    className="ql-container"
                  />
                )}
            </Box>
          </Box>
        ))}

      {/* left line */}
      <Divider
        orientation="vertical"
        sx={{
          position: "absolute",
          top: "4px",
          left: 7,
          height: "100%",
          borderWidth: 1,
          borderColor: "#d4d7da",
          borderStyle: "dashed",
        }}
      />
    </Box>
  );
};

export default CustomTimeline;
